import React, { Component } from 'react';

export class ReminderCheckbox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var key = this.props.details.user_id;
    var category = this.props.details.category;
    var contact = [this.props.details.name, this.props.maskMobile(this.props.details.mobile)].filter(Boolean).join(': ');
    return (
      <div className="row">
        <div className="col-md-8" key={key}>
          <div className="checkbox">
            <label>
              <input type="checkbox" checked={this.props.details.selected} onChange={this.props.onCheck} id={key}/>
              <b>{category}</b> ({contact})
            </label>
          </div>
        </div>
      </div>
    );
  }
}
